import { render, staticRenderFns } from "./BaseHistoryFile.vue?vue&type=template&id=37145e97"
import script from "./BaseHistoryFile.vue?vue&type=script&lang=js"
export * from "./BaseHistoryFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports